import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "../../i18n/TranslationProvider";
import SubmitButton from "./SubmitButton";

const COLORS = {
  cognitive: "#edebf3", sleep: "#ffdadb", physical: "#ffdcaf",
  emotional: "#fff3c4", speech: "#cef3c4", vision: "#c1fdf7",
};

const tSymptomName = (t, subcategory, factor) => {
  const safe = (factor || "").trim().toLowerCase()
    .replace(/ /g, "_").replace(/\//g, "_").replace(/,/g, "")
    .replace(/:/g, "").replace(/'/g, "").replace(/[()]/g, "").replace(/-/g, "_")
    .substring(0, 60);
  const key = `symptom.${subcategory}.${safe}`;
  const translated = t(key);
  return translated !== key ? translated : factor;
};

// Generic "pick one symptom from a list" modal. Used both to pick which
// top-3 slot a new/promoted symptom should replace, and to pick which
// already-tracked symptom should fill in for a paused top-3 symptom.
const SymptomReplacePicker = ({ show, title, symptoms, onConfirm, onCancel }) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState(null);

  const handleConfirm = () => {
    if (selected) {
      onConfirm(selected);
      setSelected(null);
    }
  };

  const handleCancel = () => {
    setSelected(null);
    onCancel();
  };

  return (
    <Modal show={show} onHide={handleCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {symptoms && symptoms.length > 0 ? (
          <div className="d-flex flex-wrap justify-content-center" style={{ gap: "0.5rem" }}>
            {symptoms.map((s, i) => {
              const isSelected = selected && selected.factor === s.factor;
              return (
                <button
                  key={s.factor || i}
                  type="button"
                  onClick={() => setSelected(s)}
                  style={{
                    background: COLORS[s.subcategory] || "#f4f3ee",
                    border: isSelected ? "2px solid #106995" : "1px solid #106995",
                    borderRadius: "999px",
                    padding: "0.4rem 1rem",
                    fontWeight: 600,
                    color: isSelected ? "#ffffff" : "#1a1a1a",
                    textShadow: isSelected ? "0 1px 2px rgba(0,0,0,0.35)" : "none",
                    boxShadow: isSelected ? "0 0 0 2px rgba(16,105,149,0.35)" : "none",
                  }}
                >
                  {tSymptomName(t, s.subcategory, s.factor)}
                </button>
              );
            })}
          </div>
        ) : (
          <p className="mb-0">{t("symptomreplacepicker.no_candidates")}</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-link" onClick={handleCancel}>
          {t("symptomreplacepicker.cancel")}
        </button>
        <SubmitButton disabled={!selected} greyout onClick={handleConfirm}>
          {t("symptomreplacepicker.confirm")}
        </SubmitButton>
      </Modal.Footer>
    </Modal>
  );
};

export default SymptomReplacePicker;